import { render } from "./ImportHistory.vue?vue&type=template&id=6ad0a6c9&scoped=true"
import script from "./ImportHistory.vue?vue&type=script&lang=js"
export * from "./ImportHistory.vue?vue&type=script&lang=js"

import "./ImportHistory.vue?vue&type=style&index=0&id=6ad0a6c9&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4197/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad0a6c9"]])

export default __exports__